import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { Categoria } from 'my-lib-sanfelici';
import { CategorieService } from 'my-lib-sanfelici';

@Component({
  selector: 'app-categorie-details',
  templateUrl: './categorie-details.component.html',
  styleUrls: ['./categorie-details.component.css']
})
export class CategorieDetailsComponent implements OnInit {
id:string;
    categoria: Observable<Categoria>;
    constructor(
        private route: ActivatedRoute,
        private categorieService: CategorieService
    ) { }

    ngOnInit() {
        this.id = this.route.snapshot.params['id'];
        this.categoria = this.categorieService.get(this.id);
              }

}
